import styled from "styled-components";
import theme from "../../../UI/theme";

export const RowDetailsContainer = styled.div`
    padding: 10px;
    display: grid;
    grid-gap: 10px;
    grid-template-columns: 1fr;
    background-color: ${theme.colors.darkSpace};
`